import { FETCH_ENDORSEMENT_MANAGEMENT_FAILURE, FETCH_ENDORSEMENT_MANAGEMENT_REQUEST, FETCH_ENDORSEMENT_MANAGEMENT_SUCCESS } from "../actions/types";

const initialState = {
    data: [],
    loading: true,
    error: ''
};

export const endorsementManagementDetailReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ENDORSEMENT_MANAGEMENT_REQUEST:
            return {
                ...state,
            }
        case FETCH_ENDORSEMENT_MANAGEMENT_SUCCESS:
            return {
                data: action.payload,
                loading: false
            }
        case FETCH_ENDORSEMENT_MANAGEMENT_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        default:
            return state;
    }
}